export enum AgreementType {
  PRIVACY_POLICY = 'privacyPolicy',
  TERMS_OF_SERVICE = 'termsOfService',
  SUBSCRIPTION = 'subscription',
}
